import {WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

interface ConsentManagementInitializedPayload {
    googleCookiesEnabled: boolean
}

export class ConsentManagementInitializedEvent implements WhitelabelEventWithPayload<ConsentManagementInitializedPayload> {
    type: string;
    payload: ConsentManagementInitializedPayload;
    static readonly TYPE: string = 'consent-management-initialized';

    constructor(payload: ConsentManagementInitializedPayload) {
        this.payload = payload
        this.type = ConsentManagementInitializedEvent.TYPE;
    }
}

interface ConsentChangedPayload {
    googleCookiesEnabled: boolean
}

export class ConsentChangedEvent implements WhitelabelEventWithPayload<ConsentChangedPayload> {
    type: string;
    payload: ConsentChangedPayload;
    static readonly TYPE: string = 'consent-changed';

    constructor(payload: ConsentChangedPayload) {
        this.payload = payload
        this.type = ConsentChangedEvent.TYPE;
    }
}
